<template>
  <div class="item_wrapper mt-0 pt-0 appeal pb-4" :class="errorClass">
    <div class="mx-4 px-3 mt-4">
      <div class="title_item m-0">Обращение</div>
      <div class="mb-5 mt-3">Мы стремимся сделать наш сервис лучше.</div>
      <div :class="[selected_theme ? '':'error_el']">

        <v-select
            class="themes_sel"
            v-model="selected_theme"
            :items="themes"
            label="Выбор темы"
            solo
        >
          <template v-slot:selection="{ item, index }">
            <span>{{ selected_theme[0] }}</span>
          </template>
        </v-select>
      </div>
      <!--			<div class="item_label mb-4">В рамках данной страницы вы можете сообщить о некорректной работе сервиса.-->
      <!--			</div>-->
      <div class="mb-2" :class="[usermassage.length>0 ? '':'error_el']">
        <v-textarea
            name="message"
            filled
            auto-grow
            label="Текст обращения"
            counter
            solo="false"
            rows="6"
            v-model="usermassage"
        >
        </v-textarea>
      </div>
      <div class="d-flex justify-content-end mb-2">
        <button type="submit" class="btn_red"
                @click.prevent="submit($event)">Отправить
        </button>
      </div>
    </div>

    <div v-if="confirmation" class="confirmation">
      <div class="confirmation_wrapper d-flex flex-column justify-content-between">
        <div class="confirmation__title">Отправлено!</div>
        <div class="text-center">
          <div class="confirmation__smtitle">Наш менеджер свяжется с вами</div>
          <button class="btn_red" @click="close_form">Закрыть</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "appeal",
  props: {
    themes: Array | String | Number | Boolean | Object,
  },
  data() {
    return {
      usermassage: "",
      confirmation: false,
      selected_theme: "",
      errorClass: "",
    };
  },
  methods: {
    close_form() {
      this.confirmation = false;
    },
    submit(event) {
      if (this.selected_theme.length<1 || this.usermassage.length<1) {
        this.errorClass = "errorSend";
      } else {
        this.errorClass = "";
        var newUsermassage = $.trim(this.usermassage);

        var VueObject = this;

        var theme = VueObject.selected_theme[0];

        if (newUsermassage) {
          var ajax = $.ajax({
            type: "POST",
            url: "/ajax/comment_add.php",
            data: {"massage": newUsermassage, "ajaxPost": "Y", "theme": theme},
            success: function (res) {
              VueObject.confirmation = true;
              setTimeout(function () {
                window.location.reload();
              }, 3000)
            },
            error: function (xhr, ajaxOptions, thrownError) {
              console.log(xhr.status);
              console.log(thrownError);
            }
          });
        } else {
          return false;
        }
      }

    },
  },
  watch: {
    selected_theme() {
      console.log(this.selected_theme)
    }
  },
};
</script>
<style lang="scss">
.appeal .theme--light.v-counter {
  color: rgb(135 135 135 / 60%);
}

.appeal .theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover {
  background: rgb(201 201 201 / 12%);
}

.appeal .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border-radius: 10px;

}

.themes_sel .v-input__slot {
  width: 260px;
}


.errorSend {
  & .error_el {
    & .v-input__control > .v-input__slot {
      border: 1px solid rgb(247 21 21) !important;
    }
  }

}
</style>
<style lang="scss" scoped>
.btn_red {
  width: 147px;
}


</style>
